export { default } from './ComplectationStorageContentDesktop';
